import { Box, Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import CampoTextoIA from "../components/CampoTextoIA";

const StepAntecedentes = ({ formik, camposIA, desmarcarCampoIA }) => (
  <Box>
    <Typography variant="h6" gutterBottom>
      Antecedentes
    </Typography>
    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
      Describe el contexto del cliente: su situación actual, problemas
      identificados y motivación para contratar el servicio.
    </Typography>

    <Grid container spacing={2}>
      <Grid item xs={12} id="seccion-antecedentes">
        <CampoTextoIA
          formik={formik}
          name="antecedentes"
          label="Antecedentes y contexto del cliente"
          multiline
          minRows={8}
          contextIA="Sección de antecedentes en una propuesta comercial tributaria. Describe el contexto del cliente."
          camposIA={camposIA}
          desmarcarCampoIA={desmarcarCampoIA}
        />
      </Grid>
    </Grid>
  </Box>
);

StepAntecedentes.propTypes = {
  formik: PropTypes.object.isRequired,
  camposIA: PropTypes.instanceOf(Set),
  desmarcarCampoIA: PropTypes.func,
};

StepAntecedentes.defaultProps = {
  camposIA: new Set(),
  desmarcarCampoIA: undefined,
};

export default StepAntecedentes;
